import { LandingTemplate } from "@/components/LandingTemplate";
import { IMG, FAQS } from "@/data/site";

const faqs = FAQS.filter((f) => f.c === "Group Bookings" || f.c === "Truck Parking");

export default function GroupBookings() {
  return (
    <LandingTemplate
      seo={{
        title: "Group Bookings & Room Blocks in Ottawa, KS",
        description: "Book a group room block at Super 8 by Wyndham Ottawa, Kansas — for sports teams, bus tours, church groups, wedding blocks, family reunions and corporate groups. Free bus & motorcoach parking, free breakfast. Call for group rates.",
        path: "/group-bookings",
        breadcrumbs: [{ name: "Home", path: "/" }, { name: "Group Bookings", path: "/group-bookings" }],
        faqs,
      }}
      kicker="Bring Everyone"
      heroTitle="Group Bookings"
      heroLines={["Room for", "the whole", "group"]}
      heroImage={IMG.motel}
      intro="Traveling as a team, a tour or a family reunion? We make group travel simple with room blocks, free bus and motorcoach parking, and a free breakfast that feeds everyone. Call the hotel directly and we'll help you plan the details."
      audiences={["Sports teams", "Bus tours", "Church groups", "Wedding blocks", "Family reunions", "Corporate groups", "Government groups", "School groups", "Motorcoach tours"]}
      features={[
        { icon: "Bus", title: "Bus & Motorcoach Parking", desc: "Free, oversized parking for tour buses and team transport." },
        { icon: "Users", title: "Room Blocks", desc: "Reserve a block of rooms together at a group-friendly rate." },
        { icon: "Coffee", title: "Free Breakfast for All", desc: "Everyone in your group starts the day with a free breakfast." },
        { icon: "Waves", title: "Indoor Pool", desc: "A built-in activity to keep teams and kids happy after events." },
        { icon: "Phone", title: "Direct Group Planning", desc: "Call us and we'll coordinate arrivals, rooming and rates." },
        { icon: "MapPin", title: "Easy I-35 Access", desc: "Simple highway access for buses and caravans." },
      ]}
      bandImage={IMG.exterior}
      bandTitle="Group travel, handled"
      bandText="From youth tournaments to wedding weekends and motorcoach tours, we've hosted them all. Reach out and we'll make sure your group has the rooms, the parking and the breakfast to keep everyone moving."
      benefits={[
        "Free bus & motorcoach parking",
        "Coordinated room blocks",
        "Free breakfast for the whole group",
        "Indoor pool for downtime",
        "24-hour front desk",
        "Group rates — call the hotel directly",
      ]}
      keywords={["Group hotel Ottawa KS", "Bus tour hotel Kansas", "Sports team hotel Ottawa", "Wedding room block Ottawa KS", "Church group hotel Kansas", "Motorcoach hotel Ottawa"]}
      faqs={faqs}
    />
  );
}
